import React from "react"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import { Facebook, Twitter, Instagram, Linkedin, Youtube, MapPin, Phone, Mail } from "lucide-react"
import "./footer.css"

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/logo.svg" alt="Welsh Education" className="footer-logo-img" />
            </Link>
            <p className="footer-about">
              Empowering students with future-ready skills through cutting-edge international education and expert consultancy.
            </p>
            <div className="social-links">
              <motion.a whileHover={{ y: -3 }} href="https://facebook.com/welsheducation" className="social-link"><Facebook size={20} /></motion.a>
              <motion.a whileHover={{ y: -3 }} href="#" className="social-link"><Twitter size={20} /></motion.a>
              <motion.a whileHover={{ y: -3 }} href="https://instagram.com/welsh_education" className="social-link"><Instagram size={20} /></motion.a>
              <motion.a whileHover={{ y: -3 }} href="#" className="social-link"><Linkedin size={20} /></motion.a>
              <motion.a whileHover={{ y: -3 }} href="https://youtube.com/@WELSHEDUCATION" className="social-link"><Youtube size={20} /></motion.a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h3 className="footer-heading">Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/programs">Programs</Link></li>
              <li><Link to="/events">Events</Link></li>
              <li><Link to="/study-abroad">Study Abroad</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/team">Our Team</Link></li>
              <li><Link to="/blogs">Blogs</Link></li>
            </ul>
          </div>

          {/* SEO / Resources Links */}
          <div className="footer-links">
            <h3 className="footer-heading">Free Guides</h3>
            <ul>
              <li><Link to="/study-abroad-guide">Ultimate Study Guide</Link></li>
              <li><Link to="/study-abroad-consultant-punjab">Top Consultants in Punjab</Link></li>
              <li><Link to="/services/visa">Visa Process Explained</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h3 className="footer-heading">Contact Us</h3>
            <ul className="contact-list">
              <li>
                <MapPin size={20} className="contact-icon" />
                <span>Bathinda, Punjab, India</span>
              </li>
              <li>
                <Phone size={20} className="contact-icon" />
                <span>+91 91154 00982</span>
              </li>
              <li>
                <Mail size={20} className="contact-icon" />
                <span>info@welsheducation.com</span>
              </li>
            </ul>
          </div>

          {/* Newsletter / CTA */}
          <div className="footer-newsletter">
            <h3 className="footer-heading">Newsletter</h3>
            <p className="newsletter-text">Stay updated with latest opportunities.</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Email address" className="newsletter-input" />
              <button className="newsletter-btn">Join</button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 Welsh Education. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
      {/* Footer bottom decorative line */}
      <div className="footer-glow-line" />
    </footer>
  );
};

export default Footer;
